import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import DeleteModal from "components/modal/DeleteModal";
import ViewModal from "components/modal/ViewPartialPayment";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";
import RemarkModal from "components/modal/RemarkModal";

// internal imports

const NotificationTable = ({ partialpayment, perpage, currentPage }) => {
  const { title, serviceId, serviceBlock } = useToggleDrawer();
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  const payload = { status: 2, receiver: id_employee };
  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <DeleteModal id={serviceId} body={payload} title={title} />
      <ViewModal id={serviceId} title={title} data={partialpayment} />

      <TableBody>
        {partialpayment?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="font-semibold uppercase text-xs text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.message}
            </TableCell>

            <TableCell className="text-sm text-center">
              {data.sent_time}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default NotificationTable;
